import React from 'react';
import { useSelector } from 'react-redux';
import { func, shape, string } from 'prop-types';

import { FIELDS } from '../../constants';

import LoginForm from './components/LoginForm';

function EmailAndCodeForm({ values, setFieldValue }) {
  const handleChange = (e) => setFieldValue(e.target.name, e.target.value);
  const { sendSignInCodeToEmail, signInWithEmailCodeError } = useSelector((state) => state.auth);
  return (
    <LoginForm
      codeSended={!!sendSignInCodeToEmail}
      setFieldValue={setFieldValue}
      values={values}
      handleChange={handleChange}
      errorCode={!!signInWithEmailCodeError}
    />
  );
}

EmailAndCodeForm.propTypes = {
  setFieldValue: func,
  values: shape({
    [FIELDS.EMAIL]: string
  })
};

export default EmailAndCodeForm;
